import React, { useState, useEffect } from "react";
import PersonalItem from "./PersonalItem";

const PersonalProjects = () => {
  const [projects, setProjects] = useState([]);
  const id = "Personal-Project";

  useEffect(() => {
    fetch("data/project-data.json")
      .then((res) => res.json())
      .then((res) => {
        setProjects(res["personal"]);
      });
  }, []);
  return (
    <section className="text-center space--even" id="projects">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2>Personal Projects</h2>
          </div>
        </div>
        <div className="row">
          <div className="card-deck">
            {projects.map((p, i) => (
              <PersonalItem details={p} id={`${id}-${i}`} key={`${id}-${i}`} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PersonalProjects;
